import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { MemoryPanel } from "./MemoryPanel";
import { PersonalityPanel } from "./PersonalityPanel";

export function MemoryDrawer({ open, onClose, memories, onDelete }) {
  const [tab, setTab] = useState("memories");
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent
        data-testid="memory-drawer"
        side="right"
        className="w-full sm:max-w-md bg-[var(--panel-solid)] border-l border-[var(--border-hud)] text-white p-0 flex flex-col"
      >
        <SheetHeader className="px-5 pt-5 pb-3">
          <SheetTitle className="font-display tracking-[0.15em] accent-text text-glow">SARA &amp; MOI</SheetTitle>
          <SheetDescription className="font-mono-hud text-[10px] tracking-[0.2em] text-[#8b949e]">
            Ce que Sara retient de vous, et qui elle devient au fil du temps.
          </SheetDescription>
        </SheetHeader>

        <div className="px-4 mb-2">
          <div className="inline-flex clip-corner border border-[var(--border-hud)] overflow-hidden">
            <button
              data-testid="mem-tab-souvenirs"
              onClick={() => setTab("memories")}
              className={`px-4 py-1.5 font-mono-hud text-[10px] tracking-[0.18em] uppercase transition-all ${
                tab === "memories" ? "bg-[var(--accent-a25)] text-white" : "text-[#8b949e] hover:text-white hover:bg-[var(--accent-a10)]"
              }`}
            >
              Souvenirs
            </button>
            <button
              data-testid="mem-tab-personnalite"
              onClick={() => setTab("personality")}
              className={`px-4 py-1.5 font-mono-hud text-[10px] tracking-[0.18em] uppercase transition-all ${
                tab === "personality" ? "bg-[var(--accent-a25)] text-white" : "text-[#8b949e] hover:text-white hover:bg-[var(--accent-a10)]"
              }`}
            >
              Personnalité
            </button>
          </div>
        </div>

        <div className="flex-1 min-h-0 px-4 pb-5">
          {tab === "memories" ? (
            <MemoryPanel memories={memories} onDelete={onDelete} />
          ) : (
            <PersonalityPanel open={open && tab === "personality"} />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
